import React, { useContext, useState } from "react";
import {
  Input,
  Button,
  Paragraph,
  Spacing,
  Title,
  Loader,
} from "@sicredi/react";
import logoSicredi from "../../assets/logoSicredi.png";
import styles from "./styles.module.scss";
import { PAGE } from "#/constants";
import { useNavigate } from "react-router-dom";
import { ContextAPI } from "#/contextProver/ContextProver";
import {
  inputFormatRemoveLetters,
  verificarElegibilidade,
  getAgenciaContaUserByInput,
} from "./service";
import { FEED } from "#/api/associadosFeedBackLogin";
import { CapitalIntegralizadoModal } from "#/components/AccountAgencyComponents/CapitalIntegralizadoModal";
import { NotFoundModal } from "#/components/AccountAgencyComponents/NotFoundModal";
import { CadastroErro } from "#/components/AccountAgencyComponents/CadastroErro";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";
import { findProductsByCommissioned } from "#/api/getProducts";
import {
  getValorDecodeBase64,
  loadSessionStorage,
  saveSessionStorage,
  toastErrorMenssage,
} from "#/contextProver/ContextProverServices";

export const AccountAgency: React.FC = () => {
  const {
    setProducts,
    setAgencyAccountCommissioned,
    userCPF,
    setVendasListaProposta,
    isOpenCapitalIntegralizadoModal,
    setIsOpenCapitalIntegralizadoModal,
    isLoading,
    setIsLoading,
    setIsHasAuthConta,
    logout,
    isOpenCadastroErroModal,
    setIsOpenCadastroErroModal,
  } = useContext(ContextAPI);
  const navigate = useNavigate();

  const [cooperativaInput, setCooperativaInput] = useState("");
  const [cooperativaInputRegex, setCooperativaInputRegex] = useState<
    string | undefined
  >("");
  const [contaInput, setContaInput] = useState("");
  const [contaInputRegex, setContaInputRegex] = useState<string | undefined>(
    ""
  );
  const [isErrorBlurFocusCooperativa, setIsErrorBlurFocusCooperativa] =
    useState(false);
  const [isErrorBlurFocusConta, setIsErrorBlurFocusConta] = useState(false);
  const [isShowErrorMessageApi, setIsShowErrorMessageApi] = useState(false);
  const [isOpenNotFoundModal, setIsOpenNotFoundModal] = useState(false);

  const isLoader = isLoading && !isOpenCapitalIntegralizadoModal;

  const isShowErrorMessageEmptyInputCooperativa =
    isErrorBlurFocusCooperativa && cooperativaInput.trim().length === 0;

  const isShowErrorMessageEmptyInputConta =
    isErrorBlurFocusConta && contaInput.trim().length === 0;

  const textMessageErrorEmptyInput = "Preencha o campo para continuar";
  const textMessageErrorApiCooperativa =
    "Cooperativa incorreta, tente novamente";
  const textMessageErrorApiConta = "Conta incorreta, tente novamente";

  const isDisableButton =
    contaInputRegex &&
    cooperativaInput.trim().length > 0 &&
    contaInputRegex.trim().length > 0;

  const handleFocus = (
    setIsErrorBlurFocus: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    setIsErrorBlurFocus(false);
    setIsShowErrorMessageApi(false);
  };

  const handleConfirm = async () => {
    try {
      setIsLoading(true);

      const agenciaContaUser = await getAgenciaContaUserByInput({
        cooperativaInput,
        contaInput,
        setAgencyAccountCommissioned,
        documento: userCPF,
      });
      if (agenciaContaUser) {
        const documento = getValorDecodeBase64(
          agenciaContaUser.documentoTitular
        );
        const codigoComissionado = getValorDecodeBase64(
          agenciaContaUser.codigoComissionado
        );
        const conta = getValorDecodeBase64(agenciaContaUser.conta);
        const cooperativa = getValorDecodeBase64(agenciaContaUser.agencia);

        const feedBack = await verificarElegibilidade({
          conta,
          cooperativa,
          codigoComissionado,
          documento,
        });
        if (feedBack === FEED.CAPITAL_INTEGRALIZADO) {
          setIsOpenCapitalIntegralizadoModal(true);
          setIsLoading(false);
          navigate(PAGE.AGENCIA_CONTA);
          return;
        }

        const products = await findProductsByCommissioned(codigoComissionado);
        if (products.data !== null) {
          setProducts(products.data);
        } else {
          toastErrorMenssage(
            "Código comissionado informado é inválido. Por favor, tente com outra conta."
          );
          return;
        }
        const vendasListaProposta = await getVendasListaProposta({
          codigoComissionado,
          documento,
        });
        setVendasListaProposta(vendasListaProposta);

        saveSessionStorage("isHasAuthConta", agenciaContaUser);
        setAgencyAccountCommissioned(agenciaContaUser);

        setTimeout(() => {
          setIsHasAuthConta(loadSessionStorage("isHasAuthConta"));
          setIsLoading(false);
        }, 1000);
      } else {
        setIsLoading(false);
        setIsShowErrorMessageApi(true);
        setIsOpenNotFoundModal(true);
      }
    } catch {
      setIsLoading(false);
      setIsShowErrorMessageApi(true);
      setIsOpenNotFoundModal(true);
    }
  };
  const handleSair = async () => {
    sessionStorage.clear();
    await logout();
  };

  return (
    <div className={styles.content}>
      <Loader show={isLoader} fullScreen />
      <div className={styles.content_view}>
        <Spacing appearance="x-large" />
        <div className={styles.content_logo}>
          <img
            src={logoSicredi}
            alt="logoSicredi"
            style={{ objectFit: "cover" }}
            width="100%"
            className={styles.logo}
          />
        </div>

        <Spacing appearance="small" />

        <Title as="h3">Digite sua cooperativa e conta</Title>

        <Spacing appearance="small" />

        <Paragraph>
          A cooperativa e conta digitadas serão utilizadas para o cadastro da
          sua compra.
        </Paragraph>

        <Spacing appearance="medium" />

        <div className={styles.input_container}>
          <Input
            hintMessage="Informe os 4 dígitos"
            label="Cooperativa"
            name="Cooperativa"
            type="tel"
            required={true}
            maxLength={4}
            onFocus={() => handleFocus(setIsErrorBlurFocusCooperativa)}
            onBlur={(event) =>
              setIsErrorBlurFocusCooperativa(event.target.value.trim() === "")
            }
            errorMessage={
              isShowErrorMessageEmptyInputCooperativa
                ? textMessageErrorEmptyInput
                : isShowErrorMessageApi
                ? textMessageErrorApiCooperativa
                : null
            }
            onChange={(event) =>
              inputFormatRemoveLetters({
                event,
                setInput: setCooperativaInput,
                setRegex: setCooperativaInputRegex,
              })
            }
            value={cooperativaInputRegex}
          />

          <Spacing appearance="xxx-large" />

          <Input
            hintMessage="Digite apenas números"
            label="Conta"
            name="Conta"
            type="tel"
            required={true}
            maxLength={15}
            onFocus={() => handleFocus(setIsErrorBlurFocusConta)}
            onBlur={(event) =>
              setIsErrorBlurFocusConta(event.target.value.trim() === "")
            }
            errorMessage={
              isShowErrorMessageEmptyInputConta
                ? textMessageErrorEmptyInput
                : isShowErrorMessageApi
                ? textMessageErrorApiConta
                : null
            }
            onChange={(event) =>
              inputFormatRemoveLetters({
                event,
                setInput: setContaInput,
                setRegex: setContaInputRegex,
                isLimitValueWithSpace: false,
              })
            }
            value={contaInputRegex}
          />
        </div>

        <Button
          className={styles.button}
          appearance="primary"
          disabled={!isDisableButton}
          block={true}
          onClick={handleConfirm}
        >
          Confirmar
        </Button>

        <Button
          className={styles.button_voltar_login}
          appearance="secondary"
          block={true}
          onClick={handleSair}
        >
          Voltar para login
        </Button>

        <Spacing appearance="medium" />
      </div>
      <CadastroErro
        isOpen={isOpenCadastroErroModal}
        setIsOpen={setIsOpenCadastroErroModal}
      />
      <NotFoundModal
        isOpen={isOpenNotFoundModal}
        setIsOpen={setIsOpenNotFoundModal}
      />
      <CapitalIntegralizadoModal
        isOpen={isOpenCapitalIntegralizadoModal}
        setIsOpen={setIsOpenCapitalIntegralizadoModal}
      />
    </div>
  );
};
